import * as React from 'react';

export interface FailureIconProps {
  /**
   * Size of the failure icon. default 48px
   */
  size?: number;
}

/**
 * Loading icon.
 */
export const FailureIcon: React.FC<FailureIconProps> = ({
  size = 48,
}: FailureIconProps) => {
  return <img alt="" src="/assets/auditError.svg" height={size} width={size} />;
};

export default FailureIcon;
